import React from 'react';
import PropTypes from 'prop-types';
import { ForgeBadge, ForgeTab, ForgeTabBar, ForgeToolbar } from '@tylertech/forge-react';

const Tabs = ({ headerTabButtons, activeTab = 0, handleTabChange}) => {
  return (
    <ForgeToolbar
      slot="body-header"
      className={'fixed-header-tab disableHeaderTabDivider '}
    >
      <ForgeTabBar role="tablist" slot={'before-start'} activeTab={activeTab}>
        {headerTabButtons.map((tab, i) => {
          return (
            <ForgeTab
              onclick={() => handleTabChange(i)} //this needs to go as a on-forge-tab-bar-change listener on the tab bar when it is fixed
              key={tab.name}
              className={`${activeTab === i ? 'active' : ''}`} // temp solution to manually apply active tab, when tab bar is fixed remove this line
            >
              {tab.name}
              {tab.count 
                ? <ForgeBadge theme="primary" slot="end">{tab.count}</ForgeBadge> 
                : null
              }
            </ForgeTab>
          );
        })}
      </ForgeTabBar>
    </ForgeToolbar>
  );
};

Tabs.propTypes = {
  headerTabButtons: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeTab: PropTypes.number,
  handleTabChange: PropTypes.func.isRequired,
  toolBarClass: PropTypes.string,
};

export default Tabs;
